import { eGabinetPasswordValidation } from '@dreryk/egabinet-security-frontend';
import { BindingCreator } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

export const PASSWORD_FIELD_NAME = 'password';
/**
 * To prevent password autocomplete a specific token 'new-password' has to be used
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#sect13
 */
export const NEW_PASSWORD_AUTOCOMPLETE_TOKEN = 'new-password';

export type PasswordFormBeanPart = {
   [PASSWORD_FIELD_NAME]: string;
};

type PasswordFieldProps = {
   readonly register: BindingCreator<PasswordFormBeanPart, typeof PASSWORD_FIELD_NAME>;
};

export const PasswordField = (props: PasswordFieldProps): JSX.Element => {
   return (
      <PasswordInput
         controller={props.register(PASSWORD_FIELD_NAME, {
            required: true,
            validate: (data) => {
               if (!eGabinetPasswordValidation(data as string)) {
                  return invoiceSharedComponentsTranslationKeys.password.invalid;
               }

               return undefined;
            },
         })}
         testId={PASSWORD_FIELD_NAME}
         autoComplete={NEW_PASSWORD_AUTOCOMPLETE_TOKEN}
      />
   );
};
